module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f601.ab226fe8.svg";